import { pickBy } from 'lodash-es';
import { stringify } from 'querystring';

import { logger } from '~/features/logging/logger';
import { promoApiResponseSchema } from '~/pages/api/get-promotion';

export async function getPromotion({
  pathname,
  promo,
  promoParticipation,
  forcePromo,
}: {
  pathname: string;
  promo?: string;
  promoParticipation?: string;
  forcePromo?: string;
}) {
  try {
    const searchParams = stringify(
      pickBy(
        {
          pathname,
          promo,
          promo_participation: promoParticipation,
          force_promo: forcePromo,
        },
        (value) => typeof value !== 'undefined'
      )
    );
    const response = await fetch(`/api/get-promotion?${searchParams}`, {
      credentials: 'include',
    });
    const data = promoApiResponseSchema.parse(await response.json());
    return data.promo;
  } catch (error) {
    logger.error('Failed to fetch a promotion.', {
      file: 'src/features/promotions/controllers/get-promotion.ts',
      function: 'getPromotion',
      pathname,
    });
    return null;
  }
}
